<template>
  <div>

    <!-- 会员头部封装 -->
    <Member></Member>

    <div class="container-xl">
      <div class="row">
        <div class="col-lg-4">
          <div class="file">
            <router-link to="/edit"
              ><button class="edit">编辑</button></router-link
            >
            <div class="icon">
              <img v-if="icon" :src="icon" />
              <img v-else="icon" src="../img/Frame22.png" />
              <div class="name">
                <h4>
                  {{ data.userName }}
                </h4>
                <p>{{ data.firstTime }}&emsp;</p>
              </div>
            </div>
            <div class="data">
              <span>手机</span>&emsp;&emsp;<span>{{ data.phone }}</span>
              <el-divider></el-divider>
              <span>邮箱</span>&emsp;&emsp;<span>{{ data.mail }}</span>
              <el-divider></el-divider>
              <span>地址</span>&emsp;&emsp;<span>
                {{ data.address }}
              </span>
            </div>
            <div class="Change">
              <router-link to="/change">更改密码</router-link>
              <p @click="eliminate">退出</p>
            </div>
            <div class="personal">
              <h3>个人档案</h3>
            </div>
          </div>
          <div class="Start">
            <h4>第一次带牙套时间</h4>
            <div class="body2-3">
              <span style="font-family: 'GenSenMaruGothicTW-Regular'"></span>
              <button class="edit_time">
                <el-date-picker
                  @change="change1($event)"
                  v-model="value1"
                  type="date"
                  placeholder="编辑"
                  format="yyyy - MM - dd "
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </button>
            </div>
            <div class="time">
              <h3>开始时间</h3>
            </div>
          </div>
          <div class="upload">
            <el-upload
              :headers="myHeaders"
              class="upload-demo"
              action="https://mybeame.com/user/uploadCorrectionProgress"
              :show-file-list="false"
              drag
              :on-success="uploadImgSuccess"
            >
              <i class="el-icon-upload">上传照片</i>
            </el-upload>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="schedule">
            <h2>我的矫正进度</h2>
            <div v-for="i in count">
              <div v-for="(pic, count) in picList">
                <div class="delete-time">
                  <h2 style="padding-top: 14px">
                    {{ pic.date }}
                  </h2>
                  <span class="delete" @click="Delete(pic.id)">X</span>
                  <img :src="pic.img" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getReserve } from "@/api/outpatient";
import { getUser } from "@/api/outpatient";
import {
  getCorrectionProgress,
  delCorrectionProgress,
  updateFirstTime,
} from "@/api/outpatient";

import Member from "@/components/Member.vue";

export default {
  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/personal'
    },{
      rel:'alternate',
      href:'https://mybeame.com/personal',
      hrefLang:'x-default'
    }
    ]
  },
  components: {
    Member,
  },
  data() {
    return {
      dialogTableVisible: false,
      data: [{}],
      value1: "",
      count: 1,
      counts: 1,
      uresData: {},
      uerRes: [{}],
      icon: "",
      myHeaders: {},
      picList: [],
      id: "",
    };
  },
  mounted() {
    //获取本地数据 请求携带token
    var data = JSON.parse(localStorage.getItem("data"));
    this.myHeaders.token = data.token;

    var uresData = {
      phone: null,
    };
    //获取个人信息。回显数据
    getReserve().then((res) => {
      if (res.code == 200) {
        this.uerRes = res.data;
      }
      console.log(this.uerRes);
    });
    //获取个人信息。回显数据
    getUser().then((res) => {
      this.data.userName = res.data.userName;
      this.data.phone = res.data.phone;
      this.data.address = res.data.address;
      this.data.mail = res.data.mail;
      this.value1 = res.data.updateTime;
      this.data.date = res.data.date;
      this.data.registrationTime = res.data.registrationTime;
      if (res.data.icon != "") {
        this.icon = res.data.icon;
      }
      // console.log(res);
    });

    //执行上传图片事件
    this.uploadImgSuccess();
  },
  methods: {
    //编辑带牙套时间
    change1() {
      var uresData = {
        date: this.value1,
      };
      updateFirstTime(uresData).then((res) => {});
    },

    //清除登录数据
    eliminate() {
      localStorage.removeItem("data");
      this.$router.push("/sign");
    },
    //上传矫正图片
    uploadImgSuccess() {
      //矫正进度图片请求
      getCorrectionProgress().then((res) => {
        this.picList = res.data;
        // console.log(this.picList);
      });
    },

    //删除图片事件
    Delete(Photo) {
      this.id = Photo;
      var uresData = {
        id: this.id,
      };
      this.$confirm("此操作将删除该照片，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: " 取消",
        type: "warning",
      }).then(() => {
        delCorrectionProgress(uresData).then((res) => {
          if (res.code == 200) {
            location.reload();
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin-left: 0;
  margin-right: 0;
}

.file {
  width: 100%;
  height: 480px;
  margin-top: 60px;
  padding: 20px 35px;
  border: 2px solid #00e467;
  border-radius: 0px 60px 0px 0px;
  position: relative;
  margin: auto;
  margin-top: 50px;
}
.edit {
  float: right;
  width: 94px;
  height: 30px;
  border: none;
  color: #323e48 !important;
  background: #00e467;
  border-radius: 20px;
  padding-bottom: 3px;
}
.icon {
  margin-top: 60px;
  width: 100%;
  height: 80px;
}

.icon > img {
  float: left;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.name {
  margin-left: 20px;
  float: left;
}

.name > h4 {
  font-size: 24px;
  margin: 10px 0;
  font-weight: 600;
}
.data {
  width: 100%;
  height: 180px;
  margin-top: 30px;
  float: left;
}
.Change {
  width: 100%;
  height: 20px;
  float: left;
  margin-top: 60px;
}

.Change >a {
  float: left;
  font-weight: 700;
}

.Change >p {
  float: right;
  cursor:pointer;
  font-weight: 700;
}
.personal {
  position: absolute;
  left: 20px;
  top: -15px;
  background-color: #ffffff;
}
.personal > h3 {
  font-size: 23px;
  font-weight: 700;
}
.Start {
  width: 100%;
  height: 150px;
  margin-top: 40px;
  padding: 20px 35px 0 35px;
  background: #ffffff;
  border: 2px solid #00e467;
  border-radius: 0px 60px 0px 0px;
  position: relative;
  margin: auto;
  margin-top: 30px;
}

.Start > h4 {
  font-size: 20px;
  font-weight: 700;
  margin: 20px 0 10px 0;
}
.time {
  position: absolute;
  left: 20px;
  top: -15px;
  background-color: #ffffff;
}
.time > h3 {
  font-size: 23px;
  font-weight: 700;
}

.edit_time {
  border: 1px solid #dcdfe6;
  padding: 0;
}
.upload {
  width: 100%;
  height: 37px;
  display: flex;
  align-items: center;
  margin-top: 20px;
  border: 2px solid #00e467;
  border-radius: 0px 10px 0px 0px;
}

.upload >>> .el-upload-dragger {
  width: 370px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0);
  border: none;
}
.el-upload-dragger .el-icon-upload {
  font-size: 20px;
  color: #00e467;
  margin: 7px 0 0 0;
}
.schedule {
  width: 100%;
  margin-top: 50px;
  padding: 0 5%;
}
.schedule > h2 {
  font-size: 34px;
  font-weight: 700;
}

.delete-time {
  position: relative;
  float: left;
  margin: 20px 20px;
}
.delete-time > img {
  width: 150px;
  height: 140px;
}
.delete-time > h2 {
  font-size: 21px;
}
.delete {
  padding: 4px 7px;
  font-size: 14px;
  font-weight: 700;
  background: #00e467;
  border-radius: 20px;
  border: none;
  padding-bottom: 2px;
  cursor: pointer;
  font-family: "GenSenMaruGothicTW-Bold";
  position: absolute;
  /* left: 146px;
  top: 43px; */
}
.el-button--primary {
  padding: 12px 20px !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
}
.el-button--small {
  padding: 12px 20px !important;
  border: 1px solid #dcdfe6 !important;
  margin-left: 10px !important;
  border-radius: 4px !important;
}
.el-button--default {
  padding: 12px 20px !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
}
.el-dialog__footer {
  padding: 10px 20px 60px;
}
.el-date-editor {
  width: 100% !important;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 992px) {
}
@media all and (max-width: 570px) {
  .schedule {
    padding: 0;
  }
  .delete-time {
    margin: 20px 12px;
  }
  .name > h4 {
    font-size: 21px;
  }
  .schedule > h2 {
    font-size: 27px;
  }
}
@media all and (max-width: 380px) {
  .upload >>> .el-upload-dragger {
    width: 360px;
  }
}
</style>